import {
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { Sparkles, TrendingUp } from "lucide-react";

function AgeTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;

  return (
    <div className="rounded-xl border border-slate-200 bg-slate-900/95 px-4 py-3 text-white shadow-xl backdrop-blur">
      <p className="text-xs text-slate-300">ช่วงอายุ {label}</p>
      <p className="mt-1 text-xl font-semibold">{Number(payload[0].value || 0).toLocaleString("th-TH")} <span className="text-xs font-normal text-slate-300">คน</span></p>
    </div>
  );
}

export default function AgeBarChart({ data }) {
  const chartData = (Array.isArray(data) ? data : []).map((item) => ({
    ...item,
    count: Number(item.count || 0),
  }));
  const peak = chartData.reduce((highest, item) => item.count > (highest?.count || 0) ? item : highest, null);
  const total = chartData.reduce((sum, item) => sum + item.count, 0);

  return (
    <div className="relative overflow-hidden rounded-2xl border border-slate-200/80 bg-white p-5 shadow-sm">
      <div className="pointer-events-none absolute -right-10 -top-12 h-36 w-36 rounded-full bg-teal-100/70 blur-2xl" />

      <div className="relative flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <h3 className="font-semibold text-slate-900">ช่วงอายุผู้เข้าใช้บริการ</h3>
          <p className="mt-1 text-xs text-slate-500">การกระจายตัวของผู้เข้าใช้ในแต่ละช่วงอายุ</p>
        </div>
        {peak && (
          <div className="flex items-center gap-2 rounded-xl bg-teal-50 px-3 py-2 text-teal-700 ring-1 ring-teal-100">
            <Sparkles size={15} />
            <div>
              <p className="text-[10px] font-medium uppercase tracking-wide text-[#00b3b4]">สูงสุด</p>
              <p className="text-xs font-semibold">ช่วง {peak.range} · {peak.count.toLocaleString("th-TH")} คน</p>
            </div>
          </div>
        )}
      </div>

      <div className="mt-5 h-[245px] min-h-[245px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData} margin={{ top: 8, right: 8, left: -18, bottom: 0 }} barCategoryGap="28%">
            <defs>
              <linearGradient id="ageBarGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#00b3b4" />
                <stop offset="100%" stopColor="#5eead4" />
              </linearGradient>
            </defs>
            <CartesianGrid vertical={false} stroke="#e2e8f0" strokeDasharray="4 4" />
            <XAxis dataKey="range" axisLine={false} tickLine={false} tick={{ fill: "#64748b", fontSize: 12 }} dy={8} />
            <YAxis allowDecimals={false} axisLine={false} tickLine={false} tick={{ fill: "#94a3b8", fontSize: 11 }} />
            <Tooltip content={<AgeTooltip />} cursor={{ fill: "#f0fdfa", radius: 8 }} />
            <Bar dataKey="count" fill="url(#ageBarGradient)" radius={[9, 9, 4, 4]} maxBarSize={58} />
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="mt-4 flex items-center justify-between border-t border-slate-100 pt-4">
        <span className="flex items-center gap-1.5 text-xs text-slate-400"><TrendingUp size={14} /> ข้อมูลตามตัวกรองปัจจุบัน</span>
        <span className="text-xs font-medium text-slate-600">รวม {total.toLocaleString("th-TH")} คน</span>
      </div>
    </div>
  );
}
